import { render } from "./DaySwiper.vue?vue&type=template&id=6f5821d4"
import script from "./DaySwiper.vue?vue&type=script&lang=js"
export * from "./DaySwiper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__